export default __webpack_public_path__ + "static/media/Konspekt 3.f67d795c.pdf";